import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconBell = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0002 6.33325C9.97512 6.33325 8.3335 7.97487 8.3335 9.99992V13.3333C8.3335 13.6839 8.27334 14.0205 8.16279 14.3333H15.8375C15.727 14.0205 15.6668 13.6839 15.6668 13.3333V9.99992C15.6668 7.97487 14.0252 6.33325 12.0002 6.33325ZM18.6668 14.3333C18.1145 14.3333 17.6668 13.8855 17.6668 13.3333V9.99992C17.6668 6.8703 15.1298 4.33325 12.0002 4.33325C8.87055 4.33325 6.3335 6.8703 6.3335 9.99992V13.3333C6.3335 13.8855 5.88578 14.3333 5.3335 14.3333C4.78121 14.3333 4.3335 14.781 4.3335 15.3333C4.3335 15.8855 4.78121 16.3333 5.3335 16.3333H18.6668C19.2191 16.3333 19.6668 15.8855 19.6668 15.3333C19.6668 14.781 19.2191 14.3333 18.6668 14.3333ZM9.98029 17.5008C10.1588 17.1909 10.4892 16.9999 10.8468 16.9999H13.1535C13.5111 16.9999 13.8415 17.1909 14.02 17.5008C14.1985 17.8107 14.1979 18.1923 14.0185 18.5017C13.6011 19.2213 12.8321 19.6642 12.0002 19.6642C11.1682 19.6642 10.3993 19.2213 9.98183 18.5017C9.80238 18.1923 9.80179 17.8107 9.98029 17.5008Z"
        />
      </svg>
    );
  }
);
